/**
 *  @class
 *  @function PredictiveSearchDesktop
 */
class PredictiveSearchDesktop {
	constructor() {
		this.container = document.getElementById('Search-Drawer-Desktop')
		this.form = document.getElementById('Search-Form-Desktop')
		this.input = this.form.querySelector('input[type="search"]')
		this.closeButton = document.getElementById('Search-Form-Desktop-Close')
		this.clickCapture = document.querySelector('.click-capture')
		this.defaultClickCaptureZIndex = this.clickCapture.style.zIndex
		this.defaultTab = this.container.querySelector(
			'.side-panel-content--initial'
		)
		this.predictiveSearchResults = this.container.querySelector(
			'.side-panel-content--has-tabs'
		)
		this.headerSection = document.querySelector('#shopify-section-header')
		this.announcementSection = document.querySelector(
			'#shopify-section-announcement-bar'
		)
		this.nav = document.querySelector('full-menu')

		this.setupEventListeners()
		this.defaultTabInitHeight = this.defaultTab.clientHeight
		this.setSearchContentHeight(this.defaultTabInitHeight)
	}

	setupEventListeners() {
		this.form.addEventListener('submit', this.onFormSubmit.bind(this))

		this.input.addEventListener(
			'input',
			debounce((event) => {
				this.onChange(event)
			}, 300).bind(this)
		)

		this.form.addEventListener('click', this.onFormClick.bind(this))
		this.input.addEventListener('focus', this.onFormClick.bind(this))
		this.closeButton.addEventListener('click', this.close.bind(this))
		document.addEventListener(
			'desktop-search-panel:close',
			this.close.bind(this)
		)
	}

	getQuery() {
		return this.input.value.trim()
	}

	onChange() {
		const searchTerm = this.getQuery()

		if (!searchTerm.length) {
			this.predictiveSearchResults.classList.remove('active')
			this.setSearchContentHeight(this.defaultTabInitHeight)
			return
		}
		this.predictiveSearchResults.classList.add('active')
		this.open()
		this.getSearchResults(searchTerm)
		this.setSearchContentHeight('600px')
	}

	onFormSubmit(event) {
		if (!this.getQuery().length) {
			event.preventDefault()
		}
	}

	onFormClick(e) {
		if (e.target === this.closeButton) return
		this.open()
	}

	onFocus() {
		const searchTerm = this.getQuery()

		if (!searchTerm.length) {
			return
		}

		this.getSearchResults(searchTerm)
	}

	getSearchResults(searchTerm) {
		const queryKey = searchTerm.replace(' ', '-').toLowerCase()

		this.predictiveSearchResults.classList.add('loading')

		fetch(
			`${theme.routes.predictive_search_url}?q=${encodeURIComponent(
				searchTerm
			)}&${encodeURIComponent(
				'resources[type]'
			)}=product,query&${encodeURIComponent(
				'resources[limit]'
			)}=8&${encodeURIComponent(
				'resources[limit_scope]'
			)}=each&section_id=predictive-search-desktop`
		)
			.then((response) => {
				this.predictiveSearchResults.classList.remove('loading')
				if (!response.ok) {
					var error = new Error(response.status)
					this.close()
					throw error
				}

				return response.text()
			})
			.then((text) => {
				const resultsMarkup = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('#shopify-section-predictive-search-desktop').innerHTML

				this.renderSearchResults(resultsMarkup)
			})
			.catch((error) => {
				throw error
			})
	}

	renderSearchResults(resultsMarkup) {
		this.predictiveSearchResults.innerHTML = resultsMarkup

		let _this = this,
			submitButton = this.container.querySelector('#search-results-submit')

		submitButton.addEventListener('click', () => {
			_this.form.submit()
		})
	}

	open() {
		this.setSearchDrawerTopOffset()
		this.container?.classList.add('active')
		this.closeButton?.classList.add('active')
		this.clickCapture.style.zIndex = 49
		document.getElementsByTagName('body')[0].classList.add('open-cc')
		window.HH.disableBodyScroll(this.container)
		dispatchCustomEvent('search:open')
	}

	close() {
		this.container?.classList.remove('active')
		this.closeButton?.classList.remove('active')
		this.input.value = ''
		this.input.dispatchEvent(new Event('input'))
		this.clickCapture.style.zIndex = this.defaultClickCaptureZIndex
		this.setSearchContentHeight(this.defaultTabInitHeight)
		document.getElementsByTagName('body')[0].classList.remove('open-cc')
		window.HH.enableBodyScroll(this.container)
		dispatchCustomEvent('search:close')
	}

	setSearchContentHeight(height) {
		document.documentElement.style.setProperty(
			'--search-content-height',
			`${height + 2}px`
		)
	}

	setSearchDrawerTopOffset() {
		let offset = -2

		if (this.headerSection) {
			offset += this.headerSection.offsetHeight
		}

		if (window.scrollY === 0 && this.announcementSection) {
			offset += this.announcementSection.offsetHeight
		}

		if (!document.body.classList.contains('is-scroll-down') && this.nav) {
			offset -= this.nav.offsetHeight
		}

		document.documentElement.style.setProperty(
			'--search-drawer-top-offset',
			`${offset}px`
		)
	}
}
window.addEventListener('load', () => {
	if (typeof PredictiveSearchDesktop !== 'undefined') {
		new PredictiveSearchDesktop()
	}
})
